import Header from './Header';
import Footer from './Footer';
import config from '../config';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import getConfig from 'next/config';

const Layout = ({ 
  children, 
  title = 'Water Damage Direct | Find Local Restoration Services 24/7', 
  description = 'Connect with certified water damage restoration professionals for emergency cleanup, flood repair, and mold remediation. Fast, reliable service near you.'
}) => {
  const router = useRouter();
  const { publicRuntimeConfig } = getConfig() || {};

  // Initialise based on runtime config so SSR output respects stealth mode and avoids header flash for first paint.
  const initialStealth = publicRuntimeConfig?.stealthMode || false;

  const [authenticated, setAuthenticated] = useState(() => {
    if (typeof window === 'undefined') return false;
    const cookieName = process.env.NEXT_PUBLIC_STEALTH_COOKIE_NAME || 'stealth_session';
    return document.cookie.split('; ').some(c => c.startsWith(`${cookieName}=authenticated`));
  });
  const [globalStealth, setGlobalStealth] = useState(initialStealth);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // 1. Determine if Stealth Mode is globally enabled. Prefer the explicit window flag set in _document.js.
    const stealthWindowFlag = window.__STEALTH_MODE;
    const sd = stealthWindowFlag === 'true' ||
               window.__NEXT_DATA__?.props?.pageProps?.__STEALTH_MODE === 'true';
    setGlobalStealth(sd);

    // 2. Evaluate authentication cookie presence using a configurable cookie name (default: stealth_session)
    const cookieName = process.env.NEXT_PUBLIC_STEALTH_COOKIE_NAME || 'stealth_session';
    const isAuthed = document.cookie.split('; ').some(c => c.startsWith(`${cookieName}=authenticated`));
    setAuthenticated(isAuthed);
  }, [router.asPath]);

  const hideHeaderAndFooter = false;

  return (
    <div className="flex flex-col min-h-screen origin-top scale-[0.8] mx-auto">
      {!hideHeaderAndFooter && <Header />}
      
      <main className="flex-grow container mx-auto px-4 py-8">
        {children}
      </main>
      
      {!hideHeaderAndFooter && <Footer />}
    </div>
  );
};

export default Layout;